import { IMucThuNhapHocSinhVienSelectRequest } from "../../model/request/chung-tu-nhap-hoc/IMucThuNhapHocSinhVienSelectRequest";
import { apiClient } from "../apiClient";
export const MUC_THU_NHAP_HOC_SINH_VIEN = "muc-thu-nhap-hoc-sinh-vien";
export const mucThuNhapHocSinhVienApi = {
  SelectBySinhVien: (request: IMucThuNhapHocSinhVienSelectRequest) =>
    apiClient.post(`${MUC_THU_NHAP_HOC_SINH_VIEN}/select-by-sinhvien`, request),
};
